import React from 'react';
import { Section } from '../Section';
import { FadeUp } from '../FadeUp';
import { OrderBox } from '../OrderBox';
export function Order() {
  return <Section data-id="element-167" data-mp="mwznxnygf739">
      <FadeUp data-id="element-168" data-mp="mvg8fzkmh02j">
        <OrderBox data-id="element-169" data-mp="8y9ssdv73hhj" />
      </FadeUp>
    </Section>;
}